
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.375 29.71h-8.06c-.747-3.333-1.493-6.694-2.24-10.08-.13-.58-.45-.93-1-.57-.55.36-.36 1.67-.25 2.16a6402 6402 0 012.41 10.86c.06.27.25.78.6.78h1l-1 4.59c-.12.59-.25 1.7.25 2.16.5.46.84 0 .95-.57l1.29-6.18h3.75l1.29 6.18c.11.52.48 1 1 .57.52-.43.37-1.6.25-2.16l-1-4.59h.68c1.05 0 1.06-3.15.08-3.15zM44.595 23.93h-13.7c-1 0-1 3.15 0 3.15h6.16v11.17c0 1.86 1.38 1.89 1.38 0V27.08h6.16c.97 0 .98-3.15 0-3.15z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50.265 14.15c.833 5.907 1.677 11.81 2.53 17.71.087.605.25 1.376.433 2.245.848 4.015 2.135 10.112-1.573 11.485a.48.48 0 01-.25.09h-17c-1.763 0-3.632.107-5.532.216-3.902.224-7.938.456-11.468-.216a4.27 4.27 0 01-2.95-2.26 28.3 28.3 0 00-1.631.073c-2.506.158-5.371.34-6.479-2.153-.66-1.49-.231-3.646.117-5.401.085-.425.164-.827.223-1.189l3.24-20.56c.04-.57.21-1.19.67-1.19h39c.48 0 .62.83.67 1.15zM8.274 33.157c-.503 1.95-1.11 4.306-.739 5.653.505 1.805 3.45 1.642 5.625 1.52l.195-.01c-.368-1.715-.515-3.592-.642-5.22-.073-.934-.14-1.787-.238-2.48-.627-4.4-1.253-8.793-1.88-13.18-.613 3.847-1.22 7.7-1.82 11.56-.092.573-.287 1.328-.501 2.157zm17.501 9.373h25.53c1.8-.71 1.437-2.263 1.052-3.902a17.202 17.202 0 01-.262-1.258l-1.29-9c-.573-4.08-1.157-8.153-1.75-12.22h-37.51l2 13.74c.117.814.181 1.775.25 2.797.275 4.061.615 9.1 4.53 9.843 1.55.29 3.335.19 5.047.093a43.68 43.68 0 012.403-.093z"}})])
          )
        }
      }
    